import {combineReducers} from "redux";
import authReducer from "./authReducer"
import clustersReducer from "./clustersReducer";
import themingReducer from "./themingReducer";
import navigationReducer from "./navigationReducer";
import premiumReducer from "./premiumReducer";
import testReducer from "./testReducer";
import chatReducer from "./chatReducer";

export default combineReducers({
    auth: authReducer,
    test: testReducer,
    navigation: navigationReducer,
    theming: themingReducer,
    clusters: clustersReducer,
    premium: premiumReducer,
    chat: chatReducer
})
